interface VideoCardProps {
  slug: string;
  title: string;
  duration: string;
  views: number;
  thumbnail: string;
}

export default function VideoCard({ slug, title, duration, views, thumbnail }: VideoCardProps) {
  return (
    <a href={`https://vk.com/search?q=${encodeURIComponent(title)}`} target="_blank" rel="nofollow noopener noreferrer" className="block group cursor-pointer">
      <div className="bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-200 transition-colors">
        <div className="relative w-full h-44 overflow-hidden">
          <img src={thumbnail} alt={title} title={`${title} - 挠脚心vk视频`} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" loading="lazy" />
          <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors flex items-center justify-center">
            <div className="w-12 h-12 flex items-center justify-center rounded-full bg-background-50/90">
              <i className="ri-play-fill text-xl text-primary-500 ml-0.5"></i>
            </div>
          </div>
          <span className="absolute bottom-2 right-2 bg-black/70 text-background-50 text-xs px-2 py-0.5 rounded whitespace-nowrap">{duration}</span>
        </div>
        <div className="p-3">
          <h3 className="text-sm font-medium text-foreground-900 line-clamp-2 group-hover:text-primary-500 transition-colors mb-2">{title}</h3>
          <span className="text-xs text-foreground-500 flex items-center gap-1"><i className="ri-eye-line"></i>{views.toLocaleString()} 次播放</span>
        </div>
      </div>
    </a>
  );
}